// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import '@fontsource-variable/inter';
import "@fontsource-variable/red-hat-mono";
import { QueryClientProvider } from "@tanstack/react-query";
import { WalletProvider, SafeClientProvider } from "@safecoin/dapp-kit";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./pages";
import { queryClient } from "./utils/queryClient";
import { NetworkConfigs, createSafeClient, Network } from "./utils/api/DefaultRpcClient";
import { DEFAULT_NETWORK } from "./context";

import "@safecoin/dapp-kit/dist/index.css";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SafeClientProvider
        networks={NetworkConfigs}
        createClient={createSafeClient}
        network={DEFAULT_NETWORK as Network}
      >
        <WalletProvider autoConnect enableUnsafeBurner={import.meta.env.DEV}>
          <RouterProvider router={router} />
        </WalletProvider>
      </SafeClientProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
